import type { SVGProps } from "react";
export interface LeavesIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LeavesIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LeavesIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.705 10.205a1.125 1.125 0 1 1 1.59 1.59c-.89.892-3.65 3.257-5.59 8.59l-.045.106a1.125 1.125 0 0 1-2.07-.876l.202-.537c2.114-5.465 5.033-7.994 5.913-8.873m-10.011 6.28a1.126 1.126 0 0 1-1.71 1.463zM1.804 4.23c.433-1.173 1.762-1.602 2.805-1.207l.218.097.6.294q.31.143.638.286l1.37.574.104.05a1.125 1.125 0 0 1-.853 2.07l-.108-.039-1.413-.593c-.439-.191-.87-.392-1.284-.602-.444 1.928-.796 4.121-.752 6.169.046 2.12.512 3.926 1.565 5.156l-.856.73-.854.733C1.444 16.15.93 13.73.88 11.377c-.05-2.37.366-4.834.847-6.885z"
      />
      <path
        fill={color}
        d="M18.889 2.134c1.135-.583 2.712-.152 3.202 1.174l.082.276.198.882c.45 2.103.8 4.501.75 6.816-.057 2.627-.632 5.307-2.33 7.292-2.27 2.652-5.767 3.724-9.534 3.529-1.357-.07-2.667-.786-3.362-2.054-1.444-2.636-2.413-6.803-.738-10.163l.24-.447c1.247-2.18 3.253-3.54 5.28-4.558 1.084-.544 2.213-1.008 3.269-1.443 1.072-.442 2.063-.851 2.943-1.304m1.028 2.001c-.98.504-2.06.95-3.113 1.383-1.07.44-2.12.874-3.117 1.374-1.996 1.002-3.618 2.197-4.516 3.998-1.212 2.43-.568 5.77.697 8.08.279.508.839.851 1.505.886 3.303.17 6.025-.78 7.708-2.745 1.212-1.417 1.738-3.482 1.79-5.877.05-2.366-.366-4.9-.882-7.105a.1.1 0 0 0-.072.006"
      />
    </svg>
  );
}
